import { useCallback, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
/**
 * This hook creates an element that is appaneded to the body of the html document and returns a
 * Portal to be used within a react application.
 * @example
 * ```tsx
 * const Portal = usePortal();
 *
 * return (
 *   <Portal>
 *     <div className="my-custom-style">
 *       This content is rendered outside of the normal react scope
 *     </div>
 *   </Portal>
 * );
 * ```
 */
export function usePortal() {
    // FIXME: Every usage of usePortal creates its own portal node. Is it really smart to do that?
    const portalElRef = useRef(document.createElement('div'));
    useEffect(() => {
        const portalEl = portalElRef.current;
        document.body.appendChild(portalEl);
        return () => {
            if (portalEl) {
                document.body.removeChild(portalEl);
            }
        };
    }, []);
    const Portal = useCallback(({ children }) => {
        if (portalElRef.current !== null)
            return createPortal(children, portalElRef.current);
        return null;
    }, []);
    return Portal;
}
//# sourceMappingURL=usePortal.js.map